import { BRANDSETTINGS } from "constants/action-types";

export const createOrderMinMaxRule = (rule) => ({
    payload: rule,
    type: BRANDSETTINGS.ORDERMINMAX.CREATE.START,
});

export const deleteOrderMinMaxRule = (ruleId) => ({
    payload: ruleId,
    type: BRANDSETTINGS.ORDERMINMAX.DELETE.START,
});

export const fetchOrderMinMaxRule = (ruleId) => ({
    payload: ruleId,
    type: BRANDSETTINGS.ORDERMINMAX.FETCH.START,
});

export const updateOrderMinMaxRule = (rule) => ({
    payload: rule,
    type: BRANDSETTINGS.ORDERMINMAX.UPDATE.START,
});
